require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./posts-we-need-data-engineers-not-data-scientists.json") })
        }
      }, "path---posts-we-need-data-engineers-not-data-scientists");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---posts-we-need-data-engineers-not-data-scientists!./.cache/json/posts-we-need-data-engineers-not-data-scientists.json
// module id = 412
// module chunks = 231608221292675